module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av359-15d0118c969cb570218b736a5dcf791a.jpg";